import { render } from "./Tooltip.vue?vue&type=template&id=ba8e886c"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"

import "./Tooltip.vue?vue&type=style&index=0&id=ba8e886c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/Tooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba8e886c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba8e886c', __exports__)) {
    api.reload('ba8e886c', __exports__)
  }
  
  module.hot.accept("./Tooltip.vue?vue&type=template&id=ba8e886c", () => {
    api.rerender('ba8e886c', render)
  })

}


export default __exports__